import React from 'react';
import { ColumnLayout, Container, Header } from '@cloudscape-design/components';
import { PlayersList } from './PlayersList';
import { PlayersForm } from './PlayersForm';
import { PlayersPresets } from './PlayersPresets';
import { usePlayers } from '../../hooks/api/usePlayers';
import { usePlayersPresets } from '../../hooks/api/usePlayersPresets';

export const Players: React.FC = () => {
  const { players, addPlayer, removePlayer, setPlayers } = usePlayers();
  const { presets, removePreset, addPreset } = usePlayersPresets();

  return (
    <Container header={<Header variant="h1">Players</Header>}>
      <ColumnLayout columns={2} borders="vertical">
        <PlayersList
          players={players}
          onDeletePlayer={(player) => {
            removePlayer(player);
          }}
          onSavePreset={(players) => {
            addPreset(players);
          }}
        />
        <PlayersForm
          onPlayerCreated={(p) => {
            addPlayer(p);
          }}
        />
      </ColumnLayout>
      <PlayersPresets
        presets={presets}
        onRemovePreset={removePreset}
        onPresetSelect={(preset) => {
          setPlayers(preset.players);
        }}
      />
    </Container>
  );
};
